import ContactPressForm from './ContactPressForm';

export default ContactPressForm;
